import classNames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";

import bmpSetupStyle from "components/products/bmp-setup.scss";
import { PlayIcon } from "components/products/home-icons/PlayIcon";
import style from "components/products/support/support.scss";
import { Action, Category, usageStatisticsService } from "services/statistics/UsageStatisticsService";
import { useTheme } from "utils/useTheme";

const ProductGuideHelp = (props: { setShowTrialVideo: (toShowVideo: boolean) => void }): JSX.Element => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <div className={style.support}>
            <div>
                <div className={style.supportLabel}>{t("Onboarding.home.help")}</div>
                <div className={style.needHelp}>{t("Onboarding.home.productGuide")}</div>
            </div>
            <div className={classNames(style.item, bmpSetupStyle.linkText)}>
                <PlayIcon color={theme.iconFillColor} />
                <button
                    onClick={() => {
                        props.setShowTrialVideo(true);
                        usageStatisticsService.sendEvent({
                            category: Category.TRIAL_ONBOARDING_VIDEO,
                            action: Action.WATCH_TRIAL_ONBOARDING_VIDEO,
                        });
                    }}
                >
                    <strong>{t("Onboarding.home.watchTutorial")}</strong>
                </button>
            </div>
        </div>
    );
};

export default ProductGuideHelp;
